import { Block, Document } from '@ttab/elephant-api/newsdoc'

/**
 * Whether the wire list shows a headline that is too long for one line, or cuts
 * it off. Kept on the settings document itself rather than on a pane, since it
 * is how the view reads rather than what any one column asks the index for.
 */
export const TITLE_DISPLAY_TYPE = 'core/wire-title-display'

export function readShowFullTitles(settings: Document | undefined): boolean {
  return settings?.meta?.find((block) => block.type === TITLE_DISPLAY_TYPE)?.data?.full === 'true'
}

export function titleDisplayBlock(showFullTitles: boolean): Block {
  return Block.create({
    type: TITLE_DISPLAY_TYPE,
    data: { full: showFullTitles ? 'true' : 'false' }
  })
}

/**
 * The settings document that saving only the title preference writes.
 *
 * Built from the stored panes rather than the live ones. This preference saves
 * without being asked, so it must not carry along filter changes the user has
 * not pressed save for. Any other meta the document carries is kept.
 */
export function withTitleDisplay(stored: Document | undefined, showFullTitles: boolean): Document {
  return Document.create({
    title: stored?.title ?? 'Default',
    type: 'core/wire-panes-setting',
    content: stored?.content ?? [],
    meta: [
      ...(stored?.meta ?? []).filter((block) => block.type !== TITLE_DISPLAY_TYPE),
      titleDisplayBlock(showFullTitles)
    ]
  })
}
